import request from 'api/requestUtils'
import type { actions } from '@luxuryescapes/contract-svc-agent'
import qs from 'qs'

type GetAffiliationListResponse = actions['affiliationListAvailable']['responses']['200']['content']['application/json']['result']

export async function getAgentAffiliationOptions(regionCode: string): Promise<Array<App.AgentHubAffiliationOption>> {
  const query = qs.stringify({
    region: [regionCode, 'world'],
  }, { arrayFormat: 'repeat' })
  const response = await request.get<App.ApiResponse<GetAffiliationListResponse>>(`/api/agent/available-affiliations?${query}`)
  const affiliationOptions = response.result.map(affiliation => ({
    name: affiliation.name,
    id: affiliation.id,
  }))

  return affiliationOptions
}
